import React from 'react';
import {contentUtils, User} from '../../../domain';
import {dateFormat} from '../../../lib/helpers';

export class UserViewRender extends React.Component<{
  user: User,
  adminView?: boolean
}> {
  render() {
    const user = this.props.user;
    const adminView = this.props.adminView === true;
    const roles = user.Roles.join(" ");

    return (<>
      <div className="row">
        <div className="form-group col-sm-6 col-md-4">
          <label>Identifier</label>
          <div className="text-box">{user.Id}</div>
        </div>
        <div className="form-group col-sm-6 col-md-4">
          <label>First name</label>
          <div className="text-box">{user.FirstName}</div>
        </div>
        <div className="form-group col-sm-6 col-md-4">
          <label>Last name</label>
          <div className="text-box">{user.LastName}</div>
        </div>
        <div className="form-group col-sm-6 col-md-4">
          <label>Email</label>
          <div className="text-box">{user.Email}</div>
        </div>
        <div className="form-group col-sm-6 col-md-4">
          <label>Mobile</label>
          <div className="text-box">{user.Mobile}</div>
        </div>

        <div className="w-100" />

        <div className="form-group col-sm-6 col-md-4">
          <label>Username</label>
          <div className="text-box">{user.Username}</div>
        </div>

        <div className="form-group col-sm-6 col-md-4">
          <label>Password</label>
          <div className="text-box"></div>
        </div>

        <div className="w-100" />

        <div className="form-group col-sm-6 col-md-4">
          <label>Time Zone</label>
          <div className="text-box">{user.TimeZone?.UtcName}</div>
        </div>

        <div className="form-group col-sm-6 col-md-4">
          <label>Roles</label>
          <div className="text-box">{roles}</div>
        </div>
      </div>
      {adminView &&
      <div className="row">
        <div className="form-group col-sm-6 col-md-4">
          <label>Status</label>
          <div className="text-box">{user.Status}</div>
        </div>
        <div className="form-group col-sm-6 col-md-4">
          <label>Created on</label>
          <div className="text-box">{dateFormat(user.CreationDateTime, 'wymdhms', true)}</div>
        </div>
        <div className="form-group col-sm-6 col-md-4">
          <label>Last login</label>
          <div className="text-box">{dateFormat(user.LastLoginDateTime, 'wymdhms', true)}</div>
        </div>
        <div className="form-group col-sm-6 col-md-4">
          <label>Failed login count</label>
          <div className="text-box">{user.FailedLoginCount}</div>
        </div>
        <div className="form-group col-sm-6 col-md-4">
          <label>Locked until</label>
          <div className="text-box">{dateFormat(user.LockedUntilDateTime, 'wymdhms', true)}</div>
        </div>
      </div>
      }

      {
        user.Student !== null &&
        <div className="row">
          <div className="form-group col-sm-6 col-md-4">
            <label>Student/Balance</label>
            <div className="text-box">{user.Student.Balance}</div>
          </div>
          <div className="form-group col-sm-6 col-md-4">
            <label>Student/Level</label>
            <div className="text-box">{contentUtils.fullPath(user.Student.Level!)}</div>
          </div>
          <div className="form-group col-sm-6 col-md-4">
            <label>ALFA CRM STUDENT ID</label>
            <div className="text-box">{user.Student.AlfaStudentId}</div>
          </div>
        </div>
      }
      
      {
        user.Teacher !== null &&
        <div className="row">
          <div className="form-group col-sm-6 col-md-4">
            <label>Teacher/Description</label>
            <div className="text-box">{user.Teacher.Description}</div>
          </div>
          <div className="form-group col-sm-6 col-md-4">
            <label>ALFA CRM TEACHER ID</label>
            <div className="text-box">{user.Teacher.AlfaTeacherId}</div>
          </div>
        </div>
      }
    </>);
  }
}
